import "core-js/modules/es.array.push.js";
import NavBar from '@/view/components/nav-bar/nav-bar.vue';
import { ref } from '@vue/reactivity';
import RouterUtil from '@/utils/RouterUtil';
import StorageUtil from '@/utils/StorageUtil';
import OrderApi from '@/api/order-api';
export default {
  name: 'OrderOrders',
  components: {
    NavBar
  },
  setup() {
    const title = ref('我的行程');
    const tabActive = ref(0);
    const orders = ref([]);
    const ordersPageIndex = ref(1);
    const ordersLoading = ref(false);
    const ordersFinished = ref(false);
    const waitPayOrders = ref([]);
    const waitPayOrdersPageIndex = ref(1);
    const waitPayOrdersLoading = ref(false);
    const waitPayOrdersFinished = ref(false);
    const voiceOrders = ref([]);
    const voiceOrdersPageIndex = ref(1);
    const voiceOrdersLoading = ref(false);
    const voiceOrdersFinished = ref(false);
    return {
      title,
      tabActive,
      orders,
      ordersPageIndex,
      ordersLoading,
      ordersFinished,
      waitPayOrders,
      waitPayOrdersPageIndex,
      waitPayOrdersLoading,
      waitPayOrdersFinished,
      voiceOrders,
      voiceOrdersPageIndex,
      voiceOrdersLoading,
      voiceOrdersFinished
    };
  },
  mounted() {
    this.getOrders();
    this.getWaitPayOrders();
    this.getVoiceOrders();
    if (this.$route.query && this.$route.query.waitPay === null) {
      this.tabActive = 1;
    }
    if (this.$route.query && this.$route.query.waitEvaluate === null) {
      this.tabActive = 2;
    }
    if (this.$route.query && this.$route.query.voice === null) {
      this.tabActive = 3;
    }
  },
  methods: {
    getOrders() {
      const that = this;
      OrderApi.getFinishOrders(that.ordersPageIndex, '').then(function (result) {
        if (result.success) {
          for (let i = 0; i < result.orders.length; i++) {
            if (result.orders[i].order_type !== 'ORDER_TYPE_VOICE') {
              that.orders.push(result.orders[i]);
            }
          }
        } else {
          that.ordersFinished = true;
        }
      }).finally(function () {
        that.ordersLoading = false;
      });
    },
    ordersOnLoad() {
      this.ordersPageIndex++;
      this.getOrders();
    },
    getWaitPayOrders() {
      const that = this;
      that.waitPayOrders = [];
      OrderApi.getWaitPayOrders(that.waitPayOrdersPageIndex).then(function (result) {
        if (result.success) {
          for (let i = 0; i < result.orders.length; i++) {
            that.waitPayOrders.push(result.orders[i]);
          }
        } else {
          that.waitPayOrdersFinished = true;
        }
      }).finally(function () {
        that.waitPayOrdersFinished = true;
        that.waitPayOrdersLoading = false;
      });
    },
    waitPayOrdersOnLoad() {
      // this.waitPayOrdersPageIndex++
      // this.getWaitPayOrders();
      this.waitPayOrdersFinished = true;
    },
    getVoiceOrders() {
      const that = this;
      OrderApi.getFinishOrders(that.voiceOrdersPageIndex, 'ORDER_TYPE_VOICE').then(function (result) {
        if (result.success) {
          for (let i = 0; i < result.orders.length; i++) {
            if (result.orders[i].order_type === 'ORDER_TYPE_VOICE') {
              result.orders[i].orderBeginAddress = result.orders[i].orderBeginAddress.replace('http://dadi.korange.cn:8080/', 'https://dadi.korange.cn/');
              that.voiceOrders.push(result.orders[i]);
            }
          }
        } else {
          that.voiceOrdersFinished = true;
        }
      }).finally(function () {
        that.voiceOrdersLoading = false;
      });
    },
    voiceOrdersOnLoad() {
      this.voiceOrdersPageIndex++;
      this.getVoiceOrders();
    },
    goFinish(index) {
      StorageUtil.setObject('orderData', {
        order_number: this.orders[index].order_number
      });
      RouterUtil.go('/order/finished');
    },
    goCheckout(index) {
      StorageUtil.setObject('orderData', {
        order_number: this.waitPayOrders[index].order_number
      });
      RouterUtil.go('/order/checkout');
    },
    playVoice(index) {
      const order = this.voiceOrders[index];
      if (order.orderBeginAddress.indexOf('.m4a') !== -1) {
        document.getElementById('audio-' + order.order_id).type = 'audio/m4a';
      } else {
        document.getElementById('audio-' + order.order_id).type = 'audio/wav';
      }
      document.getElementById('audio-' + order.order_id).src = order.orderBeginAddress;
    }
  }
};